import SubmitFileForm from './SubmitFileForm'

export default SubmitFileForm
